import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { chatList } from 'modules/actions/chat';
import ScrollContainer from 'react-indiana-drag-scroll';
import { isACtiveSelectBoxModal } from 'modules/actions/selectBox';
/**
 * Quick Button
 */
const Button = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  const dispatch = useDispatch();
  /* 위치기반 SendMessage event */
  const onSendMessage = (inStr, action) => {
    if (inStr === 'sysytem_Location_Allow_Y') {
      console.log('# Send geoLocation');
      window.onload = getLocation(inStr, action);
    }else {
      const paramSet = {
        inType: action,
        inStr,
      };
      dispatch(chatList(paramSet));
    }
  };

  function getLocation(inStr, action) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(function (pos) {
        const latitude = pos.coords.latitude;
        const longitude = pos.coords.longitude;
        console.log(latitude);
        console.log(longitude);
        /* global parameter */
        const paramSet = {
          inType: action,
          inStr,
          parameters: {
            latitude,
            longitude,
          },
        };
        dispatch(chatList(paramSet));
      });
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }

  return (
    <div className="quick">
      <ScrollContainer className="_quick_buttons_div">
        {items !== undefined &&
          items.map((tempItem, idx) => {
            return (
              <div className="_quick_buttons_area" key={`${id}_${idx}_area`}>
                {tempItem.button.label === '동의' || tempItem.button.label === '취소' ? (
                  <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={() => onSendMessage(tempItem.button.value, tempItem.button.action)}>
                    {ReactHtmlParser(tempItem?.button?.label || '')}
                  </div>
                ) : (
                  <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.button.value, tempItem.button.action)}>
                    {ReactHtmlParser(tempItem?.button?.label || '')}
                  </div>
                )}
              </div>
            );
          })}
      </ScrollContainer>
    </div>
  );
};
Button.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
Button.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

export default Button;
